export const pages = {
    home: {
        name: "الصفحة الأمامية",
        url: "/",
        priority: 0,
    },
    us: {
        name: "نحن",
        url: "/us",
        priority: 1,
    },
    world: {
        name: "عالم",
        url: "/world",
        priority: 1,
    },
    politics: {
        name: "سياسة",
        url: "/politics",
        priority: 1,
    },
    business: {
        name: "عمل",
        url: "/business",
        priority: 1,
    },
    opinion: {
        name: "رأي",
        url: "/opinion",
        priority: 2,
    },
    health: {
        name: "صحة",
        url: "/health",
        priority: 2,
    },
};
